@if (block) {
  <section class="testimonials" [style.color]="block.textColor">
    <div class="content block-container">
      @if (block.title) {
        <h1 [innerHtml]="block.title | safeHtml" [rtl]="block.langcode"></h1>
      }
      <lib-swiper [slides]="block.items" [options]="swiperOptions">
        <ng-template swiperContent let-slide="item">
          <div class="slide">
            <div class="testimonial-item">
              <div class="image" [cropImage]="slide.mediaImage | preSignedUrl | async" [additionalOptions]="{width: 100}"></div>
              <div class="text-wrapper">
                <div class="description ck-text" [innerHtml]="slide.text | safeHtml" [rtl]="slide.langcode"></div>
                @if (slide.author) {
                  <div class="name" [class.primary-color]="!block.textColor">- {{slide.author}}</div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </lib-swiper>
      @if (!swiperComponent?.swiper?.isBeginning || !swiperComponent?.swiper?.isEnd) {
        <div class="d-none d-lg-flex carousel-buttons-wrapper">
          <button color="primary" [style.color]="block.textColor" aria-label="Previous" [style.border-color]="block.textColor" mat-fab class="carousel-button left" [class.disabled]="swiperComponent?.swiper?.isBeginning" (click)="swiperComponent?.swiper.slidePrev()">
            <mat-icon>navigate_before</mat-icon>
          </button>
          <button color="primary" [style.color]="block.textColor" aria-label="Next" [style.border-color]="block.textColor" mat-fab class="carousel-button right" [class.disabled]="swiperComponent?.swiper?.isEnd" (click)="swiperComponent?.swiper.slideNext()">
            <mat-icon>navigate_next</mat-icon>
          </button>
        </div>
      }
    </div>
  </section>
}
